import React, { FC } from 'react';
import styled from 'styled-components';
import { Select as SelectAtom } from 'components/atoms/select';
import { StatusPickerOption } from 'components/atoms/status-picker/option';
import { byFieldName } from 'utils/by-field-name';
import { useProjectCustomFields } from 'utils/project-fields/use-project-fields';

const Option = styled(StatusPickerOption)`
  padding: var(--spacing-01) var(--spacing-03);
`;

const Select = styled(SelectAtom)`
  .ozone-select__value-container--has-value {
    .ozone-select__option {
      padding: 0;
    }
    input {
      width: 0;
    }
  }
`;

export const ProjectStatusSelect: FC<{
  isDisabled?: boolean;
  value?: any;
  onChange?(v: any): void;
  hideBehaviouralCompleteOptions?: boolean;
}> = ({
  isDisabled,
  value,
  onChange,
  hideBehaviouralCompleteOptions = false,
}) => {
  const { data: fields, isLoading } = useProjectCustomFields();
  const projectStatusField = fields?.find((field) => {
    return byFieldName(field, 'status');
  });

  return (
    <Select
      options={projectStatusField?.metaData?.options
        ?.filter((e) => e.active)
        .sort((a, b) => (a?.position || 1) - (b?.position || 1))
        .filter((option) => {
          return hideBehaviouralCompleteOptions
            ? !['blocked', 'completed', 'cancelled'].includes(
                option.label.toLowerCase(),
              )
            : option;
        })}
      components={{
        Option,
        SingleValue: StatusPickerOption,
        Input: null,
      }}
      isSearchable={false}
      isLoading={isLoading}
      onChange={onChange}
      value={value}
      isDisabled={isDisabled}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 'var(--zindex-popover-low)',
        }),
      }}
    />
  );
};
